import angular from 'angular';
import uiRouter from 'angular-ui-router';
import PubSub from 'pubsub-js';
import homeComponent from './home.component';

const homeState = {
  name: 'app.home',
  abstract: true,
  sticky: true,
  views: {
    home: {
      template: '<home></home>'
    }
  },
  title: {
    key: 'app.home.title',
    en: 'News'
  },
  onReactivate: ['$state', '$rootScope', '$timeout', 'topics', ($state, $rootScope, $timeout, topics) => {
    if ($rootScope.previousActiveElement) {
      // Restore focus to previously focused dom element
      $timeout(() => {
        PubSub.publish(topics.state.reactivate, { source: 'home' });
      }, 100); // needed 100 here to properly allow time to set focus
    }
  }],
  onInactivate: ['topics', (topics) => {
    PubSub.publish(topics.state.inactivate, { source: 'home' });
  }]
};

/* @ngInject */
function stateConfiguration($stateProvider) {
  const subStates = [
    { id: 'news', title: 'News', url: '/' },
    { id: 'extra', title: 'Extra', url: '/extra' },
    { id: 'inDepth', title: 'In Depth', url: '/indepth' },
    { id: 'features', title: 'Features', url: '/features' }
  ];

  $stateProvider
    .state(homeState);

  subStates.forEach((state) => {
    $stateProvider
      .state({
        name: `app.home.${state.id}`,
        url: state.url,
        title: {
          key: `app.home.${state.id}.title`,
          en: state.title
        }
      });
  });
}

const homeModule = angular
  .module('home', [
    uiRouter,
    'config',
    'constants',
    'app.services'
  ])
  .config(stateConfiguration)
  .component('home', homeComponent);

export default homeModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/home/home.js
 **/